import { ErrorHandler, Injectable, InjectionToken, inject } from '@angular/core';
import { SkippableErrorHandlerModel } from './skippable-error-handler.interface';

export const ERROR_HANDLERS = new InjectionToken<ErrorHandler[]>('ERROR_HANDLERS');

/**
 * GlobalErrorHandler takes ERROR_HANDLERS injection token and runs sequence of error handlers - method handleError,
 * - if one of handlers returns false, next handlers are skipped
 */
@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandler implements ErrorHandler {
  private readonly errorHandlers = inject<SkippableErrorHandlerModel[]>(ERROR_HANDLERS);

  handleError(error: Error): void {
    this.errorHandlers.every((errorHandler) => errorHandler.handleError(error) !== false);
    console.error(error);
  }
}
